import { render } from "./AddSecondaryStorage.vue?vue&type=template&id=3c26d7d6&scoped=true"
import script from "./AddSecondaryStorage.vue?vue&type=script&lang=js"
export * from "./AddSecondaryStorage.vue?vue&type=script&lang=js"

import "./AddSecondaryStorage.vue?vue&type=style&index=0&id=3c26d7d6&lang=scss&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c26d7d6"]])

export default __exports__